module.exports = __webpack_public_path__ + "img/logo-red.b0338c72.png";